import React from "react"
import { Toaster } from "sonner"
import { useLocation } from "react-router-dom"
import PublicIssueApp from "./components/public/PublicIssueApp"

import Router from "./components/Router"
import MaintenancePage from "./components/MaintenancePage"
import IncidentContext from "./components/providers/IncidentContext"
import InspectionContext from "./components/providers/InspectionContext"
import IssueContext from "./components/providers/IssueContext"
import {
  IdentityQueryClientProvider,
  OrganizationAccessProvider,
} from "./components/providers/OrganizationAccessProvider"

export default function App() {
  const location = useLocation()
  if (location.pathname.startsWith("/public/issues/")) return <PublicIssueApp />
  if (import.meta.env.VITE_MAINTENANCE_MODE === "true") {
    return <MaintenancePage />
  }

  return (
    <React.Fragment>
      <IdentityQueryClientProvider>
        <Toaster richColors position="top-right" />
        <OrganizationAccessProvider>
          <IncidentContext>
            <InspectionContext>
              <IssueContext>
                <React.Suspense fallback={<React.Fragment />}>
                  <Router />
                </React.Suspense>
              </IssueContext>
            </InspectionContext>
          </IncidentContext>
        </OrganizationAccessProvider>
      </IdentityQueryClientProvider>
    </React.Fragment>
  )
}
